import { SeriesCard as BaseSeriesCard } from './series-card'
import { SeriesCardBadgeInProgress } from './series-card-badge-in-progress'
import { SeriesCardContent } from './series-card-content'
import { SeriesCardImage } from './series-card-image'
import { SeriesCardIntensityBadge } from './series-card-intensity-badge'
import { SeriesCardMetaActive } from './series-card-meta-active'
import { SeriesCardDismissSeriesButton } from './series-card-dismiss-series-button'
import { SeriesCardProgress } from './series-card-progress'
import { SeriesCardTitle } from './series-card-title'
import React from 'react'
import { Programme } from 'src/dao/core-dao'
import { useProgrammeWorkoutProgress } from 'src/hook/use-programme-workout-progress'
import { cn } from 'src/lib/utils'
import { buildProgrammeOverviewUrl } from 'src/util/build-programme-overview-url'

export interface SeriesCardActiveProps {
  series: Programme
  className?: string
  /** Cancels the active programme (parent runs mutation). */
  onCancelSeriesClick: () => void
}

export const SeriesCardActive = ({ series, className, onCancelSeriesClick }: SeriesCardActiveProps): React.ReactElement => {
  const { completedClassesCount, totalClassesCount, isProgressReady, nextIncompleteWorkoutId, nextIncompleteWeek } =
    useProgrammeWorkoutProgress(series.id)

  return (
    <BaseSeriesCard
      series={series}
      className={cn('rounded-xl border border-success', className)}
      to={buildProgrammeOverviewUrl(series.id, {
        isProgressReady,
        nextIncompleteWeek,
        nextIncompleteWorkoutId,
      })}
    >
      <SeriesCardImage>
        <SeriesCardContent className="gap-0">
          <div className="flex shrink-0 items-center justify-between gap-2">
            <SeriesCardBadgeInProgress />
            <div className="flex min-w-0 flex-1 items-center justify-end gap-2">
              {series.intensityId ? <SeriesCardIntensityBadge className="min-w-0 shrink justify-end" /> : null}
              <SeriesCardDismissSeriesButton
                data-testid="series-card-dismiss-series"
                onDismissClick={() => onCancelSeriesClick()}
              />
            </div>
          </div>
          <div className="flex min-h-0 flex-1 flex-col justify-end">
            <SeriesCardTitle />
            <SeriesCardMetaActive />
          </div>
          <SeriesCardProgress completedCount={completedClassesCount} totalCount={totalClassesCount} isReady={isProgressReady} />
        </SeriesCardContent>
      </SeriesCardImage>
    </BaseSeriesCard>
  )
}
